export default "__VITE_ASSET__MhkFkz54__"